import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details in development only
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    // You can also log to an error reporting service here
    // Example: logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Don't show error UI for third-party script errors
      if (this.state.error?.message?.includes('share-modal.js') ||
          this.state.error?.message?.includes('content_script_bundle.js') ||
          this.state.error?.stack?.includes('extension://')) {
        return null; // Silently ignore third-party script errors
      }

      // For other errors, show a fallback UI in development
      if (process.env.NODE_ENV === 'development') {
        return (
          <div style={{
            padding: '20px',
            margin: '20px',
            border: '1px solid #ff6b6b',
            borderRadius: '4px',
            backgroundColor: '#ffeaea'
          }}>
            <h3>Something went wrong</h3>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.error && this.state.error.toString()}
            </details>
          </div>
        );
      }

      // In production, return null to prevent UI disruption
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
